import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { COOKIE_CONSENT_CONFIG, type CookieConsentConfig } from './cookie-consent-config';

export const provideCookieConsent = (config: CookieConsentConfig): EnvironmentProviders =>
  makeEnvironmentProviders([{ provide: COOKIE_CONSENT_CONFIG, useValue: config }]);
